import { useEffect } from "react";

/**
 * Seo — sets document title, meta description, canonical URL,
 * Open Graph tags and optional JSON-LD per page. No dependencies.
 * Googlebot renders JavaScript, so these tags are picked up at index time.
 */
const ORIGIN = "https://www.gettoolhaus.com";

function upsertMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

function upsertJsonLd(obj) {
  const id = "page-jsonld";
  let el = document.getElementById(id);
  if (!obj) { if (el) el.remove(); return; }
  if (!el) {
    el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = id;
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(obj);
}

export default function Seo({ title, description, path = "/", jsonLd = null }) {
  useEffect(() => {
    document.title = title;
    upsertMeta("name", "description", description);
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:url", `${ORIGIN}${path}`);
    upsertMeta("property", "og:type", "website");
    upsertMeta("name", "twitter:card", "summary");
    upsertLink("canonical", `${ORIGIN}${path}`);
    upsertJsonLd(jsonLd);
  }, [title, description, path, jsonLd]);
  return null;
}

/** JSON-LD builder for a tool page. */
export function toolJsonLd(tool) {
  return {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    name: tool.name,
    description: tool.desc,
    url: `${ORIGIN}/tool/${tool.slug}`,
    applicationCategory: "UtilityApplication",
    operatingSystem: "Any",
    offers: { "@type": "Offer", price: "0", priceCurrency: "USD" },
    publisher: { "@type": "Organization", name: "ToolHaus", url: ORIGIN },
  };
}
